import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from "@jti/store";
import { Toaster } from "@jti/ui";
import AccountLayout from "../../layouts/account/AccountLayout";
import GeneralLayout from "../../layouts/general/GeneralLayout";
import { ConditionalView } from "../conditional-view/ConditionalView";
import ScrollToElement from "../scroll-to-element/ScrollToElement";
const LayoutWrapper = ({ children }) => {
    const isLoaded = useSelector((state) => state.loyaltyCore.isLoaded);
    return (_jsxs(_Fragment, { children: [_jsx(Toaster, {}), _jsx(ConditionalView, { condition: isLoaded, children: _jsx(ScrollToElement, {}) }), children] }));
};
export const Layout = ({ children, name, isInEditor }) => {
    if (name === "account") {
        return (_jsx(LayoutWrapper, { children: _jsx(AccountLayout, { isInEditor: isInEditor, children: children }) }));
    }
    return (_jsx(LayoutWrapper, { children: _jsx(GeneralLayout, { isInEditor: isInEditor, children: children }) }));
};
//# sourceMappingURL=Layout.js.map